<template>
    <el-container class="houtai">
        <el-header>
            <el-row type="flex" class="row-bg">
                <el-col  class="header-font">
                    <h1>汉中房屋交易后台管理系统</h1>
                </el-col>
                <el-col :span="1">
                    <el-dropdown><!--  绑定指令,在methods里定义-->
                        <span class="el-dropdown-link">
                            您好<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <!--<el-dropdown-item icon="el-icon-edit" command="edit">修改密码</el-dropdown-item>-->
                            <!--<el-dropdown-item icon="el-icon-s-operation" command="quit">退出登录</el-dropdown-item>-->
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </el-header>
        <!-- logo和文字 -->
        <el-container>
            <el-aside width="180px">
                <el-menu
                        default-active="1"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                        background-color="#545c64"
                        text-color="#fff"
                        router
                        active-text-color="#ffd04b">
                    <el-submenu index=””>
                        <template slot="title"><i class="el-icon-message"></i>政策法规</template>
                        <el-menu-item-group>
                            <el-menu-item  index="/houtai/zcfg" :route="{ path: '/houtai/zcfg', query: { cxlx: 5 } }" ><i class="el-icon-message"></i>维护</el-menu-item>
                            <el-menu-item index="/houtai/zcfgedit" :route="{ path: '/houtai/zcfgedit', query: { cxlx: 5 } }">新建</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index=””>
                        <template slot="title"><i class="el-icon-message"></i>热门资讯</template>
                        <el-menu-item-group>
                            <el-menu-item  index="/houtai/xwzx" :route="{ path: '/houtai/xwzx', query: { cxlx: 6 } }"><i class="el-icon-message"></i>维护</el-menu-item>
                            <el-menu-item index="/houtai/xwzxedit" :route="{ path: '/houtai/xwzxedit', query: { cxlx: 6 }}" >新建</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index=””>
                        <template slot="title"><i class="el-icon-message"></i>表格下载</template>
                        <el-menu-item-group>
                            <el-menu-item  index="/houtai/bgxz"><i class="el-icon-message"></i>维护</el-menu-item>
                            <el-menu-item index="/houtai/bgxzedit">新建</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-container>
                <el-main>
                    <div>
                        <router-view></router-view>
                    </div>
                </el-main>
            </el-container>
        </el-container>
        <el-footer height="130px">
            <p  class="footClass">www.hzhouse.com.cn All Rights Reserved 1999-2020 苏ICP备10007646号<br>
                主管部门：汉中市住房保障和房产局 主办单位：汉中市房地产市场交易中心（汉中市房屋租赁指导中心）</p>
        </el-footer>
    </el-container>
</template>

<script>
    export default {
        name: 'commen_houtai',
        data () {
            const activeIndex = this.$route.query.id;
            return {
                msg: 'layout',
                activeIndex
            }
        },
        beforeCreate(){
            console.log(this.$route.query.id)
        },
        methods: {
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            }
        }
    };
</script>
<style>
    .houtai h1{
        font-size: 26px;
        margin-top:  5px;
        line-height: 48px;
        color: #555;
    }
    .houtai .el-header, .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
    }

    .houtai .el-aside {
        overflow: hidden;
        background-color: #545c64;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .houtai .el-menu{
        overflow: hidden;
    }
    .houtai .el-main {
        background-color: #E9EEF3;
    }

    body > .el-container {
        margin-bottom: 40px;
    }

    .houtai .el-container:nth-child(5) .el-aside,
    .houtai .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }

    .houtai .el-container:nth-child(7) .el-aside {
        line-height: 320px;
    }
</style>
<style>
    .v-application ul, .v-application ol {
        padding-left: 0 !important;
    }
    .houtai .el-footer {
        background-color: #333333;
        color: #FFFFFF;
        text-align: center;
        font-size: 13px;
        line-height: 28px;
    }
    .houtai .footClass{
        margin-top: 3%;
    }
</style>